import React from 'react';
import { SpotlightTarget } from '@atlaskit/onboarding';
export var ConditionalSpotlightTargetWrapper = function ConditionalSpotlightTargetWrapper(_ref) {
  var spotlightTargetName = _ref.spotlightTargetName,
    children = _ref.children;
  return spotlightTargetName ? /*#__PURE__*/React.createElement(SpotlightTarget, {
    name: spotlightTargetName
  }, children) : children;
};